(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rd-countdown"] && !Shopify.designMode) return;
  try {
    (function () {
    function pad(n) { return String(n).padStart(2, '0'); }

    function tick() {
      var now = Date.now();
      document.querySelectorAll('[data-rd-cd]').forEach(function (el) {
        var end = parseInt(el.getAttribute('data-end'), 10) * 1000;
        var diff = end - now;
        // Échéance atteinte : le compte à rebours disparaît, il ne repart jamais
        if (!end || diff <= 0) { el.hidden = true; return; }
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var text = (d > 0 ? d + el.getAttribute('data-lbl-d') + ' ' : '') +
                   pad(h) + el.getAttribute('data-lbl-h') + ' ' + pad(m) + el.getAttribute('data-lbl-m');
        var out = el.querySelector('[data-rd-cd-text]');
        if (out && out.textContent !== text) out.textContent = text;

        var until = el.querySelector('[data-rd-cd-until]');
        if (until && !until.textContent) {
          try {
            until.textContent = el.getAttribute('data-lbl-until') + ' ' +
              new Intl.DateTimeFormat(document.documentElement.lang || 'fr', {
                day: 'numeric', month: 'long', hour: '2-digit', minute: '2-digit'
              }).format(new Date(end));
          } catch (e) { /* la date reste simplement masquée */ }
        }
      });
    }

    tick();
    // Toutes les 30 s : jours, heures, minutes. Pas de secondes qui défilent.
    setInterval(tick, 30000);
    document.addEventListener('shopify:section:load', tick);
  })();
  } catch(e) { console.error(e); }
})();

})();
